/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getParticipantAnswers = /* GraphQL */ `
  query GetParticipantAnswers($participantId: ID!) {
    getParticipantAnswers(participantId: $participantId)
  }
`;
export const getExcelTemplate = /* GraphQL */ `
  query GetExcelTemplate {
    getExcelTemplate
  }
`;
export const getFormParticipants = /* GraphQL */ `
  query GetFormParticipants($formId: ID!) {
    getFormParticipants(formId: $formId) {
      id
      formId
      email
      firstName
      lastName
      title
      status
      selectedAnswers {
        question
        answer
        __typename
      }
      remindersSent
      dateAccepted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getProjectForms = /* GraphQL */ `
  query GetProjectForms($projectId: ID!) {
    getProjectForms(projectId: $projectId) {
      id
      name
      configuration {
        traitIds
        language
        deadline
        reminder
        invitation
        __typename
      }
      projectId
      status
      createdAt
      __typename
    }
  }
`;
export const getCustomerProjects = /* GraphQL */ `
  query GetCustomerProjects($customerId: ID!) {
    getCustomerProjects(customerId: $customerId) {
      id
      projectName
      customerId
      participants {
        email
        firstName
        lastName
        title
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getFormScores = /* GraphQL */ `
  query GetFormScores($formId: ID!) {
    getFormScores(formId: $formId)
  }
`;
export const getParticipantScores = /* GraphQL */ `
  query GetParticipantScores($formId: ID!, $participantId: ID!) {
    getParticipantScores(formId: $formId, participantId: $participantId)
  }
`;
export const sendInvitationEmail = /* GraphQL */ `
  query SendInvitationEmail($formId: ID!) {
    sendInvitationEmail(formId: $formId)
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers {
    getUsers {
      username
      isSuperUser
      __typename
    }
  }
`;
export const generateReport = /* GraphQL */ `
  query GenerateReport(
    $reportName: String!
    $language: Language!
    $formIds: [ID!]!
    $makeAggregatedReport: Boolean!
  ) {
    generateReport(
      reportName: $reportName
      language: $language
      formIds: $formIds
      makeAggregatedReport: $makeAggregatedReport
    )
  }
`;
export const getCostReport = /* GraphQL */ `
  query GetCostReport($fromDate: AWSDate!, $toDate: AWSDate!) {
    getCostReport(fromDate: $fromDate, toDate: $toDate)
  }
`;
export const getOrderOfQuestions = /* GraphQL */ `
  query GetOrderOfQuestions($id: ID!) {
    getOrderOfQuestions(id: $id) {
      id
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrderOfQuestionss = /* GraphQL */ `
  query ListOrderOfQuestionss(
    $filter: ModelOrderOfQuestionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderOfQuestionss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTrait = /* GraphQL */ `
  query GetTrait($id: ID!) {
    getTrait(id: $id) {
      id
      symbol
      idealScene {
        language
        value
        __typename
      }
      name {
        language
        value
        __typename
      }
      questions {
        items {
          id
          trait {
            id
            symbol
            idealScene {
              language
              value
              __typename
            }
            name {
              language
              value
              __typename
            }
            questions {
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          translations {
            language
            formulation
            answerOptions {
              answer1
              answer2
              answer3
              answer4
              answer5
              __typename
            }
            __typename
          }
          scores {
            answer1
            answer2
            answer3
            answer4
            answer5
            __typename
          }
          answerSequence {
            answer1
            answer2
            answer3
            answer4
            answer5
            __typename
          }
          orderNumber
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTraits = /* GraphQL */ `
  query ListTraits(
    $filter: ModelTraitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTraits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        symbol
        idealScene {
          language
          value
          __typename
        }
        name {
          language
          value
          __typename
        }
        questions {
          items {
            id
            trait {
              id
              symbol
              createdAt
              updatedAt
              __typename
            }
            translations {
              language
              formulation
              __typename
            }
            scores {
              answer1
              answer2
              answer3
              answer4
              answer5
              __typename
            }
            answerSequence {
              answer1
              answer2
              answer3
              answer4
              answer5
              __typename
            }
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuestion = /* GraphQL */ `
  query GetQuestion($id: ID!) {
    getQuestion(id: $id) {
      id
      trait {
        id
        symbol
        idealScene {
          language
          value
          __typename
        }
        name {
          language
          value
          __typename
        }
        questions {
          items {
            id
            trait {
              id
              symbol
              createdAt
              updatedAt
              __typename
            }
            translations {
              language
              formulation
              __typename
            }
            scores {
              answer1
              answer2
              answer3
              answer4
              answer5
              __typename
            }
            answerSequence {
              answer1
              answer2
              answer3
              answer4
              answer5
              __typename
            }
            orderNumber
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      translations {
        language
        formulation
        answerOptions {
          answer1
          answer2
          answer3
          answer4
          answer5
          __typename
        }
        __typename
      }
      scores {
        answer1
        answer2
        answer3
        answer4
        answer5
        __typename
      }
      answerSequence {
        answer1
        answer2
        answer3
        answer4
        answer5
        __typename
      }
      orderNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQuestions = /* GraphQL */ `
  query ListQuestions(
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        trait {
          id
          symbol
          idealScene {
            language
            value
            __typename
          }
          name {
            language
            value
            __typename
          }
          questions {
            items {
              id
              orderNumber
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        translations {
          language
          formulation
          answerOptions {
            answer1
            answer2
            answer3
            answer4
            answer5
            __typename
          }
          __typename
        }
        scores {
          answer1
          answer2
          answer3
          answer4
          answer5
          __typename
        }
        answerSequence {
          answer1
          answer2
          answer3
          answer4
          answer5
          __typename
        }
        orderNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      consultant
      companyName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        consultant
        companyName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuestionsInForm = /* GraphQL */ `
  query GetQuestionsInForm($slug: String!) {
    getQuestionsInForm(slug: $slug) {
      id
      selectedAnswer
      translations {
        language
        formulation
        answerOptions {
          answer1
          answer2
          answer3
          answer4
          answer5
          __typename
        }
        __typename
      }
      answerSequence {
        answer1
        answer2
        answer3
        answer4
        answer5
        __typename
      }
      __typename
    }
  }
`;
export const isGDPRAccepted = /* GraphQL */ `
  query IsGDPRAccepted($participantId: ID!) {
    isGDPRAccepted(participantId: $participantId)
  }
`;
